import { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import config from "../../config/config";
import axios from "axios";

const RollbackReceivePayment = ({
  Open,
  RollbackOriginalId,
  RollbackId,
  handleClose,
}) => {
  const HandleRollbackTxn = () => {
    axios
      .post(`${config.salesconfigBaseUrl}/receivings/RollbackTxn`, {
        previousid: RollbackOriginalId,
        RollBackId: RollbackId,
      })
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          handleClose();
        }
      })
      .catch((err) => {});
  };

  return (
    <>
      <Modal open={Open} onClose={handleClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            className="modal-content text-center p-4"
            style={{
              width: "300px",
              height: "auto",
              borderRadius: "8px",
              background: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "transparent",
                fontSize: "18px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              &times;
            </button>
            <h6 className="mb-6">RollBack Transaction</h6>
            <p className="mb-4">
              Due to a technical issue, your previous transaction data was not
              saved properly in our system. Please click the 'OK' button to save
              the data correctly.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                className="btn btn-primary"
                style={{ minWidth: "80px" }}
                onClick={() => HandleRollbackTxn()}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RollbackReceivePayment;
